import React from 'react';
import Picker, { setDefaultLocale } from 'react-datepicker';
import { TextField, IconButton } from '@material-ui/core';
import TodayIcon from '@material-ui/icons/Today';
import ClearIcon from '@material-ui/icons/Clear';

import { useStyles } from './styles';
import { IDatePicker } from './datepicker.interface';

setDefaultLocale('pt-br');

export const DatePicker = (props: IDatePicker) => {
  const { selected, onChange, label, value, minDate, variant, disabled } = props;
  const classes = useStyles();
  const [cleared, setCleared] = React.useState(false);

  const handleClear = () => {
    onChange(null);
    setCleared(true);
  };

  return (
    <div className={classes.root}>
      <Picker
        selected={selected}
        minDate={minDate || null}
        dateFormat="dd/MM/yyyy"
        onChange={(date) => {
          setCleared(false);
          onChange(date);
        }}
        disabled={disabled}
        customInput={
          <TextField
            variant={variant || 'standard'}
            label={label}
            placeholder="dd/mm/aaaa"
            value={cleared ? '' : value}
            fullWidth
            InputProps={{
              endAdornment: (
                <React.Fragment>
                  {value && !disabled && (
                    <IconButton className={classes.button} onClick={handleClear}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  <TodayIcon />
                </React.Fragment>
              )
            }}
          />
        }
      />
    </div>
  );
};
